<template>
	<div class="val-container">
		<template v-if="type=='val'">
			<el-row class="mb-2" v-for="(item,index) in list">
				<el-col :span="12">
					<el-input :disabled="disabled" maxlength='50' show-word-limit clearable placeholder="请填写" @blur="updateData" v-model="item.value" class="input-with-select">

					</el-input>
				</el-col>
				<el-col v-if="!disabled" class="px-2" :span="12">
					<el-button-group>
						<el-button @click="addlistClick(index)" type="primary">添加</el-button>
						<el-button v-if="list.length>1" @click="dellistClick(index)" type="primary">删除</el-button>
						<el-button v-if="list.length>1" @click="uplistClick(index)" type="primary">上移</el-button>
						<el-button v-if="list.length>1" @click="downlistClick(index)" type="primary">下移</el-button>
					</el-button-group>
				</el-col>

			</el-row>
			
		</template>
		<template v-if="type=='dict'">
			<el-row class="mb-2" v-for="(item,index) in list">
				<el-col :span="8">
					<el-input :disabled="disabled" maxlength='50' show-word-limit clearable  placeholder="请填写参数名" @blur="updateData" v-model="item.key" class="input-with-select">

					</el-input>
				</el-col>
				<el-col class="pl-2" :span="8">
					<el-input :disabled="disabled" maxlength='50' show-word-limit clearable placeholder="请填写参数值"  @blur="updateData" v-model="item.value" class="input-with-select">

					</el-input>
				</el-col>
				<el-col v-if="!disabled" class="pl-2" :span="8">
					<el-button-group>
						<el-button @click="addlistClick(index)" type="primary">添加</el-button>
						<el-button v-if="list.length>1" @click="dellistClick(index)" type="primary">删除</el-button>
						<el-button v-if="list.length>1" @click="uplistClick(index)" type="primary">上移</el-button>
						<el-button v-if="list.length>1" @click="downlistClick(index)" type="primary">下移</el-button>
					</el-button-group>
				</el-col>

			</el-row>
			
		</template>
	</div>
</template>
<script>
	export default {
		props: {
			type: {
				type: String,
				default: 'val'
			},
			value: {
				type: String,
				default: ''
			},
			placeholder: {
				type: String,
				default: ''
			},
			disabled:{
				type:Boolean,
				default:false
			}
		},
		data() {
			return {
				list:  this.type=='val'?[{value:''}]:[{key:'',value:''}],
				lists: this.type=='val'?[{value:''}]:[{key:'',value:''}]
			}
		},
	
		watch: {
		    		 value(newval){
		    				   this.list=newval?JSON.parse( newval):this.lists;
		    		 }
		    	   },
		methods: {
			updateData(){
				var data=JSON.stringify(this.list)
				data=data=="[]"?JSON.stringify(  this.type=='val'?[{value:''}]:[{key:'',value:''}]):data;
						  this.$emit('input',data)
			},
			uplistClick(i) {
				if(i!=0){
				        this.list[i] = this.list.splice(i-1, 1, this.list[i])[0];
				    }else{
				        this.list.push(this.list.shift());
				    }
					 this.$emit('input',JSON.stringify(this.list))
			},
			downlistClick(i) {
				if(i!=this.list.length-1){
				        this.list[i] = this.list.splice(i+1, 1, this.list[i])[0];
				    }else{
				       this.list.unshift( this.list.splice(i,1)[0]);
				    }
					 this.$emit('input',JSON.stringify(this.list))
			},
			addlistClick(i) {
				let obj=this.type=='val'?{value:''}:{key:'',value:''};
					this.list.push(obj);
					// this.$emit('input',JSON.stringify(this.list))
			}, 
			dellistClick(i) {
				this.list.splice(i,1); 
				 this.$emit('input',JSON.stringify(this.list))
			},
		},
		mounted() {
		 this.list=this.value?JSON.parse( this.value):this.lists;
		}
	}
</script>
